/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TrainingTimeWindow = 'LAST_1_MONTH' | 'LAST_3_MONTHS' | 'LAST_6_MONTHS' | 'LAST_12_MONTHS' | 'ALL_HISTORICAL_DATA';

export const TrainingTimeWindow = {
    Last1Month: 'LAST_1_MONTH' as TrainingTimeWindow,
    Last3Months: 'LAST_3_MONTHS' as TrainingTimeWindow,
    Last6Months: 'LAST_6_MONTHS' as TrainingTimeWindow,
    Last12Months: 'LAST_12_MONTHS' as TrainingTimeWindow,
    AllHistoricalData: 'ALL_HISTORICAL_DATA' as TrainingTimeWindow
};

